import React, { PureComponent } from "react";
import { Mutation, ApolloConsumer } from "react-apollo";
import classNames from "classnames";

import Cta from "../cta/cta";
import Me from "../me/me";

import convertProfilePicUrl from "../../utils/convert-profile-pic-url";

import sendMessage from "./send-message-query-and-mutation";

import "./send-message.scss";

import { LOCAL_TOGGLE_OVERLAY_MUTATION } from "../../apollo-state/graphql/mutations";

class SendMessage extends PureComponent {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }
  sendMessage = (client, me, convoId) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        sendMessage(
          client,
          this.props.id,
          me,
          this.props.profilePic,
          this.props.firstName,
          convoId
        )
          .then((resp) => {
            this.setState({
              loading: false,
            });
          })
          .catch((e) => {
            console.log(e);
          });
      }
    );
  };
  render() {
    const { loading } = this.state;
    const {
      isJustImage,
      isCtaButton,
      isCornerButton,
      firstName,
      profilePic,
      convoId,
    } = this.props;

    return (
      <ApolloConsumer>
        {(client) => (
          <Me>
            {({ data }) => (
              <Mutation mutation={LOCAL_TOGGLE_OVERLAY_MUTATION}>
                {(toggleOverlay) => (
                  <>
                    {isJustImage && (
                      <button
                        className="send-message--profile-image"
                        onClick={() =>
                          data?.me
                            ? this.sendMessage(client, data.me, convoId)
                            : toggleOverlay()
                        }
                        disabled={loading}
                      >
                        <img
                          src={convertProfilePicUrl(profilePic, 32, 32)}
                          alt={firstName}
                        />
                      </button>
                    )}
                    {isCtaButton && (
                      <div className="send-message">
                        <Cta
                          loading={loading}
                          disabled={loading}
                          tag="button"
                          text="Send message"
                          onClick={() =>
                            data?.me
                              ? this.sendMessage(client, data.me)
                              : toggleOverlay()
                          }
                          icon="message"
                        />
                      </div>
                    )}
                    {isCornerButton && (
                      <button
                        className={classNames("send-message--corner-button", {
                          "send-message--corner-button-loading": loading,
                        })}
                        disabled={loading}
                        title={`Message ${firstName}`}
                        onClick={() =>
                          data?.me
                            ? this.sendMessage(client, data.me)
                            : toggleOverlay()
                        }
                      ></button>
                    )}
                  </>
                )}
              </Mutation>
            )}
          </Me>
        )}
      </ApolloConsumer>
    );
  }
}

export default SendMessage;
